import { IConfig } from 'unleash-proxy-client';

export const featureFlagsConfig: IConfig = {
  url: window.env.FEATURE_FLAGS_URL,
  clientKey: window.env.FEATURE_FLAGS_CLIENT_KEY,
  disableRefresh: true,
  appName: 'sfa',
};
